export class OAuthIntegration {
	appId: string;
	venueKey: number;
	accessToken: string;
	tokenType: string;
	expiresIn: number;
	refreshToken: string;
	scope: string;
	created: Date;
	updated: Date;
	expirationDateTime: Date;
	status: number;

	public constructor(init?: Partial<OAuthIntegration>) {
		Object.assign(this, init);
	}
}
